import { CartBrowserEffects } from './cart-browser.effects';
import { CartCloneEffects } from './cart-clone.effects';
import { CartEntryEffects } from './cart-entry.effect';
import { CartOrganizationEffects } from './cart-organization.effects';
import { CartPromotionsEffects } from './cart-promotions.effect';
import { CartVoucherBrowserEffects } from './cart-voucher-browser.effects';
import { CustomCartVoucherEffects } from './cart-voucher.effect';
import { CartEffects } from './cart.effect';
import { CompareCartEffects } from './compare-cart.effects';
import { MultiCartEffects } from './multi-cart.effect';
import { SavedCartEffects } from './saved-cart.effect';
import { ShareCartEffects } from './share-cart.effects';

export const effects: any[] = [
  CompareCartEffects,
  CartBrowserEffects,
  CartEffects,
  ShareCartEffects,
  CartCloneEffects,
  CustomCartVoucherEffects,
  CartVoucherBrowserEffects,
  CartPromotionsEffects,
  CartOrganizationEffects,
  SavedCartEffects,
  CartEntryEffects,
  MultiCartEffects,
];
